<template>
    <b-modal size="xl" :no-close-on-backdrop="true"
             :hide-footer="true" body-class="nopad" :title="$t('item_add_new')" ref="innermodal">
        <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-12">
                <table class="table table-striped table-sm no-bor">
                    <thead>
                    <tr>
                        <th>{{$t('no')}}</th>
                        <th>{{$t('quote_no')}}</th>
                        <th>{{$t('customer')}}</th>
                        <th>{{$t('phone')}}</th>
                        <th>{{$t('date')}}</th>
                        <th>{{$t('grand_total')}}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(ret, index) in records" :key="index">
                        <td>{{index+1}}</td>
                        <td><a href="javascript:void(0)" @click="$emit('selected', ret)">{{ ret.Num }}</a></td>
                        <td>{{ret.CustomerName}}</td>
                        <td>{{ret.Phone}}</td>
                        <td>{{ret.Date}}</td>
                        <td>{{ret.GrandTotal}}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </b-modal>
</template>
<script>
    export default {
        data() {
            return {
                query:{
                    Page: 1,
                    Total: 0,
                    Limit: 25,
                    Text: '',
                    CompanyId: this.$store.state.company.Id
                },
                records:[]
            }
        },
        created: function() {
            this.toList();
        },
        methods: {
            toList: function(){
                var loading = this.$loading.show();
                var req = {
                    Text: '',
                    CompanyId: this.$store.state.company.Id
                };
                if(this.query.Text != '')
                    req.Text = this.query.Text;
                this.$api().post('quote/list/approved', req).then(res => {
                    if(this.$isValid(res)){
                        this.records = res.data.Json.quoteList;
                        this.query.total = res.data.Total;
                    }
                }).finally(function(){ loading.hide();});
            },
        }
    };
</script>
<style scoped>
    .item-img-element{
        display: flex;
    }
    .item-img-element .card-img-top{
        width: 105px;
        height: 105px;
        overflow: hidden;
        border-radius: 3px;
        border: 1px solid #ddd;
    }
    .item-img-element img{
        width: 105px;
        height: 105px;
    }
    .item-img-element .side-right{
        width: 100%;
        padding-left: 10px;
    }
</style>